// extracted by mini-css-extract-plugin
module.exports = {"span":"styles_span__fwgQQ","title":"styles_title__1HPpj","success":"styles_success__KmjuZ"};